const url = {
    api: (path = "") => {
        let url = process.env.REACT_APP_API_URL;
        if (!url.startsWith("http://") && !url.startsWith("https://")) {
            url = window.location.origin + url;
        }
        return url + path;
    }
};

export default url;